import React from "react";

const MobileNavToken = () => (
  <svg
    width="58"
    height="34"
    viewBox="0 0 58 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58 26.8006C54.4383 24.9799 52 21.2747 52 17C52 12.7253 54.4383 9.02013 58 7.19942V4.25C58 3.12283 57.5571 2.04183 56.7686 1.2448C55.9801 0.447766 54.9108 0 53.7957 0H4.2043C3.08925 0 2.01987 0.447766 1.23141 1.2448C0.442951 2.04183 0 3.12283 0 4.25V7.19942C3.56168 9.02013 6 12.7253 6 17C6 21.2747 3.56168 24.9799 0 26.8006V29.75C0 30.8772 0.442951 31.9582 1.23141 32.7552C2.01987 33.5522 3.08925 34 4.2043 34H53.7957C54.9108 34 55.9801 33.5522 56.7686 32.7552C57.5571 31.9582 58 30.8772 58 29.75V26.8006Z"
      fill="#2eb790"
    />
  </svg>
);

const TokenBackground = () => (
  <svg
    width="500"
    height="350"
    viewBox="0 0 350 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M128.367 245.11C9.04088 294.462 -20.626 281.96 -20.626 281.96L-28.5371 -160.374H250.99C250.99 -160.374 416.757 -126.577 434.265 -33.3731C446.132 29.7983 426.068 40.1357 417.958 100.654C409.848 161.173 401.472 220.178 360.944 245.11C305.805 279.031 247.694 195.758 128.367 245.11Z"
      fill="#2eb790"
    />
  </svg>
);

const CloseModal = () => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 1.69842L15.7375 0.0771484L8.75 6.50473L1.7625 0.0771484L0 1.69842L6.9875 8.126L0 14.5536L1.7625 16.1748L8.75 9.74726L15.7375 16.1748L17.5 14.5536L10.5125 8.126L17.5 1.69842Z"
      fill="#D8D8D8"
    />
  </svg>
);

const MoreOptions = () => (
  <svg
    width="21"
    height="4"
    viewBox="0 0 21 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.75 3.9375C3.82005 3.9375 4.6875 3.07005 4.6875 2C4.6875 0.929948 3.82005 0.0625 2.75 0.0625C1.67995 0.0625 0.8125 0.929948 0.8125 2C0.8125 3.07005 1.67995 3.9375 2.75 3.9375Z"
      fill="#C4C4C4"
    />
    <path
      d="M10.625 3.9375C11.6951 3.9375 12.5625 3.07005 12.5625 2C12.5625 0.929948 11.6951 0.0625 10.625 0.0625C9.55495 0.0625 8.6875 0.929948 8.6875 2C8.6875 3.07005 9.55495 3.9375 10.625 3.9375Z"
      fill="#C4C4C4"
    />
    <path
      d="M18.5 3.9375C19.5701 3.9375 20.4375 3.07005 20.4375 2C20.4375 0.929948 19.5701 0.0625 18.5 0.0625C17.4299 0.0625 16.5625 0.929948 16.5625 2C16.5625 3.07005 17.4299 3.9375 18.5 3.9375Z"
      fill="#C4C4C4"
    />
  </svg>
);

const CloudUpload = () => (
  <svg
    width="19"
    height="15"
    viewBox="0 0 19 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 7.56152V14.1249"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.619 12.2216C16.3303 11.8339 16.8922 11.2203 17.216 10.4777C17.5398 9.73509 17.6071 8.90581 17.4073 8.12073C17.2075 7.33564 16.7519 6.63946 16.1125 6.14205C15.473 5.64464 14.6861 5.37434 13.876 5.37381H12.9572C12.7364 4.52001 12.325 3.72737 11.7538 3.05546C11.1827 2.38356 10.4666 1.84988 9.65948 1.49455C8.85237 1.13922 7.97521 0.971487 7.09394 1.00396C6.21267 1.03643 5.35022 1.26826 4.57145 1.68202C3.79267 2.09578 3.11782 2.6807 2.59765 3.39281C2.07747 4.10493 1.72549 4.9257 1.56818 5.79342C1.41087 6.66115 1.45232 7.55324 1.68941 8.40264C1.9265 9.25204 2.35306 10.0366 2.93703 10.6975"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.4181 10.4786L9.50105 7.56152L6.58398 10.4786"
      stroke="black"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SearchIcon = () => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.19306 10.7341H5.9997L6.2856 10.49C5.06032 9.22476 4.42726 7.49855 4.77442 5.66389C5.25432 3.1514 7.6232 1.14503 10.4822 0.837746C14.8013 0.367784 18.4363 3.58521 17.9053 7.40817C17.5582 9.93874 15.2914 12.0355 12.4528 12.4603C10.3801 12.7675 8.42984 12.2072 7.00035 11.1227L6.72466 11.3757V12.0897L2.38513 15.9307C1.96649 16.3013 1.28237 16.3013 0.863737 15.9307C0.445099 15.5602 0.445099 14.9547 0.863737 14.5841L5.19306 10.7341ZM11.3195 10.7341C13.8619 10.7341 15.9143 8.91747 15.9143 6.66708C15.9143 4.41669 13.8619 2.6001 11.3195 2.6001C8.777 2.6001 6.72466 4.41669 6.72466 6.66708C6.72466 8.91747 8.777 10.7341 11.3195 10.7341Z"
      fill="white"
    />
  </svg>
);

const Remove = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0.875C6.75195 0.875 0.875 6.75195 0.875 14C0.875 21.248 6.75195 27.125 14 27.125C21.248 27.125 27.125 21.248 27.125 14C27.125 6.75195 21.248 0.875 14 0.875ZM19.625 14.7031C19.625 14.832 19.5195 14.9375 19.3906 14.9375H8.60938C8.48047 14.9375 8.375 14.832 8.375 14.7031V13.2969C8.375 13.168 8.48047 13.0625 8.60938 13.0625H19.3906C19.5195 13.0625 19.625 13.168 19.625 13.2969V14.7031Z"
      fill="#E4475B"
    />
  </svg>
);

const SmallRemove = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0.875C6.75195 0.875 0.875 6.75195 0.875 14C0.875 21.248 6.75195 27.125 14 27.125C21.248 27.125 27.125 21.248 27.125 14C27.125 6.75195 21.248 0.875 14 0.875ZM19.625 14.7031C19.625 14.832 19.5195 14.9375 19.3906 14.9375H8.60938C8.48047 14.9375 8.375 14.832 8.375 14.7031V13.2969C8.375 13.168 8.48047 13.0625 8.60938 13.0625H19.3906C19.5195 13.0625 19.625 13.168 19.625 13.2969V14.7031Z"
      fill="#E4475B"
    />
  </svg>
);

const Add = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 0.875C6.75195 0.875 0.875 6.75195 0.875 14C0.875 21.248 6.75195 27.125 14 27.125C21.248 27.125 27.125 21.248 27.125 14C27.125 6.75195 21.248 0.875 14 0.875ZM19.625 14.7031C19.625 14.832 19.5195 14.9375 19.3906 14.9375H14.9375V19.3906C14.9375 19.5195 14.832 19.625 14.7031 19.625H13.2969C13.168 19.625 13.0625 19.5195 13.0625 19.3906V14.9375H8.60938C8.48047 14.9375 8.375 14.832 8.375 14.7031V13.2969C8.375 13.168 8.48047 13.0625 8.60938 13.0625H13.0625V8.60938C13.0625 8.48047 13.168 8.375 13.2969 8.375H14.7031C14.832 8.375 14.9375 8.48047 14.9375 8.60938V13.0625H19.3906C19.5195 13.0625 19.625 13.168 19.625 13.2969V14.7031Z"
      fill="#2eb790"
    />
  </svg>
);

const CalendarIcon = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.7137 9.57185V27.0718C31.7137 28.3032 31.2246 29.4841 30.3539 30.3548C29.4832 31.2255 28.3022 31.7147 27.0709 31.7147H4.92801C3.69665 31.7147 2.51572 31.2255 1.64502 30.3548C0.774313 29.4841 0.285156 28.3032 0.285156 27.0718V9.57185H31.7137ZM8.48659 21.0018C8.01298 21.0018 7.55878 21.19 7.22389 21.5249C6.88901 21.8598 6.70087 22.314 6.70087 22.7876C6.70087 23.2612 6.88901 23.7154 7.22389 24.0503C7.55878 24.3851 8.01298 24.5733 8.48659 24.5733C8.96019 24.5733 9.41439 24.3851 9.74928 24.0503C10.0842 23.7154 10.2723 23.2612 10.2723 22.7876C10.2723 22.314 10.0842 21.8598 9.74928 21.5249C9.41439 21.19 8.96019 21.0018 8.48659 21.0018ZM15.9937 21.0018C15.5201 21.0018 15.0659 21.19 14.731 21.5249C14.3962 21.8598 14.208 22.314 14.208 22.7876C14.208 23.2612 14.3962 23.7154 14.731 24.0503C15.0659 24.3851 15.5201 24.5733 15.9937 24.5733C16.4673 24.5733 16.9215 24.3851 17.2564 24.0503C17.5913 23.7154 17.7794 23.2612 17.7794 22.7876C17.7794 22.314 17.5913 21.8598 17.2564 21.5249C16.9215 21.19 16.4673 21.0018 15.9937 21.0018ZM8.48659 13.859C8.01298 13.859 7.55878 14.0471 7.22389 14.382C6.88901 14.7169 6.70087 15.1711 6.70087 15.6447C6.70087 16.1183 6.88901 16.5725 7.22389 16.9074C7.55878 17.2423 8.01298 17.4304 8.48659 17.4304C8.96019 17.4304 9.41439 17.2423 9.74928 16.9074C10.0842 16.5725 10.2723 16.1183 10.2723 15.6447C10.2723 15.1711 10.0842 14.7169 9.74928 14.382C9.41439 14.0471 8.96019 13.859 8.48659 13.859ZM15.9937 13.859C15.5201 13.859 15.0659 14.0471 14.731 14.382C14.3962 14.7169 14.208 15.1711 14.208 15.6447C14.208 16.1183 14.3962 16.5725 14.731 16.9074C15.0659 17.2423 15.5201 17.4304 15.9937 17.4304C16.4673 17.4304 16.9215 17.2423 17.2564 16.9074C17.5913 16.5725 17.7794 16.1183 17.7794 15.6447C17.7794 15.1711 17.5913 14.7169 17.2564 14.382C16.9215 14.0471 16.4673 13.859 15.9937 13.859ZM23.4994 13.859C23.0258 13.859 22.5716 14.0471 22.2367 14.382C21.9019 14.7169 21.7137 15.1711 21.7137 15.6447C21.7137 16.1183 21.9019 16.5725 22.2367 16.9074C22.5716 17.2423 23.0258 17.4304 23.4994 17.4304C23.973 17.4304 24.4272 17.2423 24.7621 16.9074C25.097 16.5725 25.2852 16.1183 25.2852 15.6447C25.2852 15.1711 25.097 14.7169 24.7621 14.382C24.4272 14.0471 23.973 13.859 23.4994 13.859ZM27.0709 0.286133C28.3022 0.286133 29.4832 0.775289 30.3539 1.64599C31.2246 2.5167 31.7137 3.69763 31.7137 4.92899V7.42899H0.285156V4.92899C0.285156 3.69763 0.774313 2.5167 1.64502 1.64599C2.51572 0.775289 3.69665 0.286133 4.92801 0.286133H27.0709Z"
      fill="#2eb790"
    />
  </svg>
);

const EditArrow = () => (
  <svg
    width="8"
    height="12"
    viewBox="0 0 8 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.589844 1.41L5.16984 6L0.589843 10.59L1.99984 12L7.99984 6L1.99984 6.16331e-08L0.589844 1.41Z"
      fill="#2eb790"
    />
  </svg>
);

const StickerBlue = () => (
  <svg
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.558 78.1706C-2.25252 59.5471 -7.19554 21.3087 12.1631 7.26667e-05L153 0V101.23C153 112.258 130.055 132.6 111.454 109.251C86.6759 78.1483 42.3691 99.4792 18.558 78.1706Z"
      fill="#6380F2"
    />
    <path
      d="M66.7542 9.5C76.2772 9.5 84.0103 17.2331 84.0103 26.7561C84.0103 36.2791 76.2771 44.0122 66.7542 44.0122C57.2312 44.0122 49.498 36.2791 49.498 26.7561C49.498 17.2331 57.2312 9.5 66.7542 9.5Z"
      stroke="white"
      strokeWidth="5"
    />
    <path
      d="M58.248 42.5664V61.1936L66.715 56.1135L75.1819 61.1936V42.5664"
      stroke="white"
      strokeWidth="5"
      strokeMiterlimit="3"
    />
    <path
      d="M69.748 32C70.714 32 71.498 32.784 71.498 33.75L71.497 34.712C71.614 36.902 69.986 38.009 67.065 38.009C64.155 38.009 62.498 36.919 62.498 34.75V33.75C62.498 32.784 63.282 32 64.248 32H69.748ZM58.748 27H63.124C62.9496 27.679 62.9563 28.3919 63.1435 29.0675C63.3307 29.743 63.6919 30.3577 64.191 30.85L64.353 31.001L64.248 31C63.6479 30.9998 63.0641 31.1959 62.5858 31.5585C62.1075 31.921 61.761 32.4301 61.599 33.008L61.565 33.009C58.655 33.009 56.998 31.919 56.998 29.75V28.75C56.998 27.784 57.782 27 58.748 27ZM75.248 27C76.214 27 76.998 27.784 76.998 28.75L76.997 29.712C77.114 31.902 75.486 33.009 72.565 33.009L72.396 33.007C72.2423 32.4623 71.9246 31.9781 71.4861 31.6203C71.0476 31.2625 70.5095 31.0484 69.945 31.007L69.748 31L69.643 31.001C70.1982 30.5134 70.607 29.8813 70.824 29.175C71.041 28.4688 71.0576 27.7162 70.872 27.001L75.248 27ZM66.998 25C67.392 25 67.7821 25.0776 68.1461 25.2284C68.5101 25.3791 68.8408 25.6001 69.1194 25.8787C69.3979 26.1573 69.6189 26.488 69.7697 26.8519C69.9205 27.2159 69.998 27.606 69.998 28C69.998 28.394 69.9205 28.7841 69.7697 29.1481C69.6189 29.512 69.3979 29.8427 69.1194 30.1213C68.8408 30.3999 68.5101 30.6209 68.1461 30.7716C67.7821 30.9224 67.392 31 66.998 31C66.2024 31 65.4393 30.6839 64.8767 30.1213C64.3141 29.5587 63.998 28.7956 63.998 28C63.998 27.2044 64.3141 26.4413 64.8767 25.8787C65.4393 25.3161 66.2024 25 66.998 25ZM61.498 20C62.2937 20 63.0568 20.3161 63.6194 20.8787C64.182 21.4413 64.498 22.2044 64.498 23C64.498 23.7956 64.182 24.5587 63.6194 25.1213C63.0568 25.6839 62.2937 26 61.498 26C60.7024 26 59.9393 25.6839 59.3767 25.1213C58.8141 24.5587 58.498 23.7956 58.498 23C58.498 22.2044 58.8141 21.4413 59.3767 20.8787C59.9393 20.3161 60.7024 20 61.498 20ZM72.498 20C73.2937 20 74.0568 20.3161 74.6194 20.8787C75.182 21.4413 75.498 22.2044 75.498 23C75.498 23.7956 75.182 24.5587 74.6194 25.1213C74.0568 25.6839 73.2937 26 72.498 26C71.7024 26 70.9393 25.6839 70.3767 25.1213C69.8141 24.5587 69.498 23.7956 69.498 23C69.498 22.2044 69.8141 21.4413 70.3767 20.8787C70.9393 20.3161 71.7024 20 72.498 20Z"
      fill="white"
    />
  </svg>
);

const PremiumTeamSticker = () => (
  <svg
    width="63"
    height="71"
    viewBox="0 0 63 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.916 45.5538C-0.74733 34.2245 -3.7552 10.9628 8.02464 -1.99996L87.377 -2V59.5815C87.377 66.2905 73.4149 78.6652 62.0958 64.4609C47.0183 45.5402 26.4052 58.5165 11.916 45.5538Z"
      fill="#6380F2"
    />
    <path
      d="M34.8338 6.5C41.2745 6.5 46.5046 11.73 46.5046 18.1707C46.5046 24.6115 41.2745 29.8415 34.8338 29.8415C28.3931 29.8415 23.1631 24.6114 23.1631 18.1707C23.1631 11.73 28.3931 6.5 34.8338 6.5Z"
      stroke="white"
      strokeWidth="3"
    />
    <path
      d="M29.1631 28.7109V41.1291L34.8077 37.7423L40.4523 41.1291V28.7109"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="3"
    />
    <path
      d="M36.8291 21.667C37.4731 21.667 37.9958 22.1897 37.9958 22.8337L37.9951 23.475C38.0731 24.935 36.9878 25.673 35.0404 25.673C33.1004 25.673 31.9958 24.9463 31.9958 23.5003V22.8337C31.9958 22.1897 32.5184 21.667 33.1624 21.667H36.8291ZM29.4958 18.3337H32.4131C32.2968 18.7863 32.3013 19.2616 32.4261 19.712C32.5509 20.1624 32.7917 20.5721 33.1244 20.9003L33.2324 21.001L33.1624 21.0003C32.7623 21.0002 32.3731 21.1309 32.0543 21.3726C31.7354 21.6143 31.5044 21.9537 31.3964 22.339L31.3738 22.3397C29.4338 22.3397 28.3291 21.613 28.3291 20.167V19.5003C28.3291 18.8563 28.8518 18.3337 29.4958 18.3337ZM40.4958 18.3337C41.1398 18.3337 41.6624 18.8563 41.6624 19.5003L41.6618 20.1417C41.7398 21.6017 40.6544 22.3397 38.7071 22.3397L38.5944 22.3383C38.4919 21.9752 38.2801 21.6524 37.9878 21.4139C37.6954 21.1753 37.3367 21.0326 36.9604 21.005L36.8291 21.0003L36.7591 21.001C37.1292 20.6759 37.4017 20.2545 37.5464 19.7837C37.6911 19.3128 37.7022 18.8111 37.5784 18.3343L40.4958 18.3337ZM34.9958 17.0003C35.2584 17.0003 35.5185 17.0521 35.7611 17.1526C36.0038 17.2531 36.2243 17.4004 36.41 17.5861C36.5957 17.7718 36.743 17.9923 36.8435 18.235C36.944 18.4776 36.9958 18.7377 36.9958 19.0003C36.9958 19.263 36.944 19.523 36.8435 19.7657C36.743 20.0083 36.5957 20.2288 36.41 20.4145C36.2243 20.6003 36.0038 20.7476 35.7611 20.8481C35.5185 20.9486 35.2584 21.0003 34.9958 21.0003C34.4653 21.0003 33.9566 20.7896 33.5816 20.4145C33.2065 20.0395 32.9958 19.5308 32.9958 19.0003C32.9958 18.4699 33.2065 17.9612 33.5816 17.5861C33.9566 17.211 34.4653 17.0003 34.9958 17.0003ZM31.3291 13.667C31.8595 13.667 32.3682 13.8777 32.7433 14.2528C33.1184 14.6279 33.3291 15.1366 33.3291 15.667C33.3291 16.1974 33.1184 16.7061 32.7433 17.0812C32.3682 17.4563 31.8595 17.667 31.3291 17.667C30.7987 17.667 30.29 17.4563 29.9149 17.0812C29.5398 16.7061 29.3291 16.1974 29.3291 15.667C29.3291 15.1366 29.5398 14.6279 29.9149 14.2528C30.29 13.8777 30.7987 13.667 31.3291 13.667ZM38.6624 13.667C39.1929 13.667 39.7016 13.8777 40.0766 14.2528C40.4517 14.6279 40.6624 15.1366 40.6624 15.667C40.6624 16.1974 40.4517 16.7061 40.0766 17.0812C39.7016 17.4563 39.1929 17.667 38.6624 17.667C38.132 17.667 37.6233 17.4563 37.2482 17.0812C36.8731 16.7061 36.6624 16.1974 36.6624 15.667C36.6624 15.1366 36.8731 14.6279 37.2482 14.2528C37.6233 13.8777 38.132 13.667 38.6624 13.667Z"
      fill="white"
    />
  </svg>
);

const OrganizationSticker = () => (
  <svg
    width="63"
    height="71"
    viewBox="0 0 63 71"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M100,100 h200 a20,20 0 0 1 20,20 v200 a20,20 0 0 1 -20,20 h-200 a20,20 0 0 1 -20,-20 v-200 a20,20 0 0 1 20,-20 z" />
    <path
      d="M11.916 45.5538C-0.74733 34.2245 -3.7552 10.9628 8.02464 -1.99996L87.377 -2V59.5815C87.377 66.2905 73.4149 78.6652 62.0958 64.4609C47.0183 45.5402 26.4052 58.5165 11.916 45.5538Z"
      fill="#F28A4B"
    />
    <path
      d="M34.8348 6.5C41.2755 6.5 46.5055 11.73 46.5055 18.1707C46.5055 24.6115 41.2755 29.8415 34.8348 29.8415C28.3941 29.8415 23.1641 24.6114 23.1641 18.1707C23.1641 11.73 28.3941 6.5 34.8348 6.5Z"
      stroke="white"
      strokeWidth="3"
    />
    <path
      d="M24.209 24L17.9999 34.7544L24.5817 34.6437L27.7767 40.3991L33.9857 29.6446"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="3"
    />
    <path
      d="M44.7773 24L50.9864 34.7544L44.4047 34.6437L41.2097 40.3991L35.0006 29.6446"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="3"
    />
    <path
      d="M36.8301 21.666C37.4741 21.666 37.9967 22.1887 37.9967 22.8327L37.9961 23.474C38.0741 24.934 36.9887 25.672 35.0414 25.672C33.1014 25.672 31.9967 24.9453 31.9967 23.4993V22.8327C31.9967 22.1887 32.5194 21.666 33.1634 21.666H36.8301ZM29.4967 18.3327H32.4141C32.2978 18.7853 32.3022 19.2606 32.4271 19.711C32.5519 20.1614 32.7927 20.5711 33.1254 20.8993L33.2334 21L33.1634 20.9993C32.7633 20.9992 32.3741 21.13 32.0553 21.3717C31.7364 21.6134 31.5054 21.9527 31.3974 22.338L31.3747 22.3387C29.4347 22.3387 28.3301 21.612 28.3301 20.166V19.4993C28.3301 18.8553 28.8527 18.3327 29.4967 18.3327ZM40.4967 18.3327C41.1407 18.3327 41.6634 18.8553 41.6634 19.4993L41.6627 20.1407C41.7407 21.6007 40.6554 22.3387 38.7081 22.3387L38.5954 22.3373C38.4929 21.9742 38.2811 21.6514 37.9888 21.4129C37.6964 21.1743 37.3377 21.0316 36.9614 21.004L36.8301 20.9993L36.7601 21C37.1302 20.675 37.4027 20.2535 37.5474 19.7827C37.692 19.3119 37.7031 18.8101 37.5794 18.3333L40.4967 18.3327ZM34.9967 16.9993C35.2594 16.9993 35.5195 17.0511 35.7621 17.1516C36.0048 17.2521 36.2252 17.3994 36.411 17.5851C36.5967 17.7709 36.744 17.9913 36.8445 18.234C36.945 18.4766 36.9967 18.7367 36.9967 18.9993C36.9967 19.262 36.945 19.5221 36.8445 19.7647C36.744 20.0074 36.5967 20.2278 36.411 20.4136C36.2252 20.5993 36.0048 20.7466 35.7621 20.8471C35.5195 20.9476 35.2594 20.9993 34.9967 20.9993C34.4663 20.9993 33.9576 20.7886 33.5825 20.4136C33.2075 20.0385 32.9967 19.5298 32.9967 18.9993C32.9967 18.4689 33.2075 17.9602 33.5825 17.5851C33.9576 17.2101 34.4663 16.9993 34.9967 16.9993ZM31.3301 13.666C31.8605 13.666 32.3692 13.8767 32.7443 14.2518C33.1194 14.6269 33.3301 15.1356 33.3301 15.666C33.3301 16.1964 33.1194 16.7052 32.7443 17.0802C32.3692 17.4553 31.8605 17.666 31.3301 17.666C30.7996 17.666 30.2909 17.4553 29.9159 17.0802C29.5408 16.7052 29.3301 16.1964 29.3301 15.666C29.3301 15.1356 29.5408 14.6269 29.9159 14.2518C30.2909 13.8767 30.7996 13.666 31.3301 13.666ZM38.6634 13.666C39.1938 13.666 39.7026 13.8767 40.0776 14.2518C40.4527 14.6269 40.6634 15.1356 40.6634 15.666C40.6634 16.1964 40.4527 16.7052 40.0776 17.0802C39.7026 17.4553 39.1938 17.666 38.6634 17.666C38.133 17.666 37.6243 17.4553 37.2492 17.0802C36.8741 16.7052 36.6634 16.1964 36.6634 15.666C36.6634 15.1356 36.8741 14.6269 37.2492 14.2518C37.6243 13.8767 38.133 13.666 38.6634 13.666Z"
      fill="white"
    />
  </svg>
);

const StickerOrange = () => (
  <svg
    width="117"
    height="120"
    viewBox="0 0 117 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.558 78.1706C-2.25252 59.5471 -7.19554 21.3087 12.1631 7.26667e-05L153 0V101.23C153 112.258 130.055 132.6 111.454 109.251C86.6759 78.1483 42.3691 99.4792 18.558 78.1706Z"
      fill="#F28A4B"
    />
    <path
      d="M67.8438 45.2261L77.0493 61.1706L81.7862 52.6378L91.5443 52.8019L82.3387 36.8574"
      stroke="white"
      strokeWidth="5"
      strokeMiterlimit="3"
    />
    <path
      d="M75.7281 12.7815C83.8657 17.4797 86.6586 27.9031 81.9604 36.0406C77.2622 44.1782 66.8388 46.9711 58.7012 42.2729C50.5637 37.5747 47.7707 27.1513 52.469 19.0138L50.3039 17.7637L52.469 19.0137C57.1672 10.8762 67.5906 8.08324 75.7281 12.7815Z"
      stroke="white"
      strokeWidth="5"
    />
    <path
      d="M52.2055 36.8574L43 52.8019L52.7581 52.6378L57.495 61.1706L66.7005 45.2261"
      stroke="white"
      strokeWidth="5"
      strokeMiterlimit="3"
    />
    <path
      d="M69.75 31C70.716 31 71.5 31.784 71.5 32.75L71.499 33.712C71.616 35.902 69.988 37.009 67.067 37.009C64.157 37.009 62.5 35.919 62.5 33.75V32.75C62.5 31.784 63.284 31 64.25 31H69.75ZM58.75 26H63.126C62.9515 26.679 62.9582 27.3919 63.1455 28.0675C63.3327 28.743 63.6939 29.3577 64.193 29.85L64.355 30.001L64.25 30C63.6498 29.9998 63.0661 30.1959 62.5878 30.5585C62.1095 30.921 61.7629 31.4301 61.601 32.008L61.567 32.009C58.657 32.009 57 30.919 57 28.75V27.75C57 26.784 57.784 26 58.75 26ZM75.25 26C76.216 26 77 26.784 77 27.75L76.999 28.712C77.116 30.902 75.488 32.009 72.567 32.009L72.398 32.007C72.2443 31.4623 71.9265 30.9781 71.488 30.6203C71.0495 30.2625 70.5115 30.0484 69.947 30.007L69.75 30L69.645 30.001C70.2001 29.5134 70.6089 28.8813 70.8259 28.175C71.0429 27.4688 71.0596 26.7162 70.874 26.001L75.25 26ZM67 24C67.394 24 67.7841 24.0776 68.1481 24.2284C68.512 24.3791 68.8427 24.6001 69.1213 24.8787C69.3999 25.1573 69.6209 25.488 69.7716 25.8519C69.9224 26.2159 70 26.606 70 27C70 27.394 69.9224 27.7841 69.7716 28.1481C69.6209 28.512 69.3999 28.8427 69.1213 29.1213C68.8427 29.3999 68.512 29.6209 68.1481 29.7716C67.7841 29.9224 67.394 30 67 30C66.2044 30 65.4413 29.6839 64.8787 29.1213C64.3161 28.5587 64 27.7956 64 27C64 26.2044 64.3161 25.4413 64.8787 24.8787C65.4413 24.3161 66.2044 24 67 24ZM61.5 19C62.2956 19 63.0587 19.3161 63.6213 19.8787C64.1839 20.4413 64.5 21.2044 64.5 22C64.5 22.7956 64.1839 23.5587 63.6213 24.1213C63.0587 24.6839 62.2956 25 61.5 25C60.7044 25 59.9413 24.6839 59.3787 24.1213C58.8161 23.5587 58.5 22.7956 58.5 22C58.5 21.2044 58.8161 20.4413 59.3787 19.8787C59.9413 19.3161 60.7044 19 61.5 19ZM72.5 19C73.2956 19 74.0587 19.3161 74.6213 19.8787C75.1839 20.4413 75.5 21.2044 75.5 22C75.5 22.7956 75.1839 23.5587 74.6213 24.1213C74.0587 24.6839 73.2956 25 72.5 25C71.7044 25 70.9413 24.6839 70.3787 24.1213C69.8161 23.5587 69.5 22.7956 69.5 22C69.5 21.2044 69.8161 20.4413 70.3787 19.8787C70.9413 19.3161 71.7044 19 72.5 19Z"
      fill="white"
    />
  </svg>
);

const Token14 = () => (
  <>
    <svg
      width="37"
      height="23"
      viewBox="0 0 37 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: "middle" }}
    >
      <path
        id="p1"
        d="M33.6971 11.5C33.6971 12.2625 33.9924 12.9938 34.5181 13.5329C35.0437 14.0721 35.7566 14.375 36.5 14.375V20.125C36.5 20.8875 36.2047 21.6188 35.6791 22.1579C35.1534 22.6971 34.4405 23 33.6971 23H3.30287C2.5595 23 1.84658 22.6971 1.32094 22.1579C0.795301 21.6188 0.5 20.8875 0.5 20.125V14.375C1.24337 14.375 1.95629 14.0721 2.48193 13.5329C3.00757 12.9938 3.30287 12.2625 3.30287 11.5C3.30287 10.7375 3.00757 10.0062 2.48193 9.46707C1.95629 8.9279 1.24337 8.625 0.5 8.625V2.875C0.5 2.1125 0.795301 1.38123 1.32094 0.842068C1.84658 0.302901 2.5595 0 3.30287 0H33.6971C34.4405 0 35.1534 0.302901 35.6791 0.842068C36.2047 1.38123 36.5 2.1125 36.5 2.875V8.625C35.7566 8.625 35.0437 8.9279 34.5181 9.46707C33.9924 10.0062 33.6971 10.7375 33.6971 11.5Z"
        fill="#2eb790"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        stroke="white"
        strokeWidth="3%"
        dy=".3em"
        style={{
          fontSize: "16px",
          fontFamily: "Open Sans",
          letterSpacing: ".15px",
        }}
      >
        14
      </text>
    </svg>
    <span
      style={{
        verticalAlign: "middle",
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: "18px",
        letterSpacing: "0.15px",
        color: "#2eb790",
        marginLeft: "0.3rem",
      }}
    >
      Tokens
    </span>
  </>
);

const Token50 = () => (
  <>
    <svg
      width="37"
      height="23"
      viewBox="0 0 37 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: "middle" }}
    >
      <path
        id="p1"
        d="M33.6971 11.5C33.6971 12.2625 33.9924 12.9938 34.5181 13.5329C35.0437 14.0721 35.7566 14.375 36.5 14.375V20.125C36.5 20.8875 36.2047 21.6188 35.6791 22.1579C35.1534 22.6971 34.4405 23 33.6971 23H3.30287C2.5595 23 1.84658 22.6971 1.32094 22.1579C0.795301 21.6188 0.5 20.8875 0.5 20.125V14.375C1.24337 14.375 1.95629 14.0721 2.48193 13.5329C3.00757 12.9938 3.30287 12.2625 3.30287 11.5C3.30287 10.7375 3.00757 10.0062 2.48193 9.46707C1.95629 8.9279 1.24337 8.625 0.5 8.625V2.875C0.5 2.1125 0.795301 1.38123 1.32094 0.842068C1.84658 0.302901 2.5595 0 3.30287 0H33.6971C34.4405 0 35.1534 0.302901 35.6791 0.842068C36.2047 1.38123 36.5 2.1125 36.5 2.875V8.625C35.7566 8.625 35.0437 8.9279 34.5181 9.46707C33.9924 10.0062 33.6971 10.7375 33.6971 11.5Z"
        fill="#2eb790"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        stroke="white"
        strokeWidth="3%"
        dy=".3em"
        style={{
          fontSize: "16px",
          fontFamily: "Open Sans",
          letterSpacing: ".15px",
        }}
      >
        50
      </text>
    </svg>
    <span
      style={{
        verticalAlign: "middle",
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: "18px",
        letterSpacing: "0.15px",
        color: "#2eb790",
        marginLeft: "0.3rem",
      }}
    >
      Tokens
    </span>
  </>
);

const Token64 = () => (
  <>
    <svg
      width="37"
      height="23"
      viewBox="0 0 37 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ verticalAlign: "middle" }}
    >
      <path
        id="p1"
        d="M33.6971 11.5C33.6971 12.2625 33.9924 12.9938 34.5181 13.5329C35.0437 14.0721 35.7566 14.375 36.5 14.375V20.125C36.5 20.8875 36.2047 21.6188 35.6791 22.1579C35.1534 22.6971 34.4405 23 33.6971 23H3.30287C2.5595 23 1.84658 22.6971 1.32094 22.1579C0.795301 21.6188 0.5 20.8875 0.5 20.125V14.375C1.24337 14.375 1.95629 14.0721 2.48193 13.5329C3.00757 12.9938 3.30287 12.2625 3.30287 11.5C3.30287 10.7375 3.00757 10.0062 2.48193 9.46707C1.95629 8.9279 1.24337 8.625 0.5 8.625V2.875C0.5 2.1125 0.795301 1.38123 1.32094 0.842068C1.84658 0.302901 2.5595 0 3.30287 0H33.6971C34.4405 0 35.1534 0.302901 35.6791 0.842068C36.2047 1.38123 36.5 2.1125 36.5 2.875V8.625C35.7566 8.625 35.0437 8.9279 34.5181 9.46707C33.9924 10.0062 33.6971 10.7375 33.6971 11.5Z"
        fill="#2eb790"
      />
      <text
        x="50%"
        y="50%"
        textAnchor="middle"
        stroke="white"
        strokeWidth="3%"
        dy=".3em"
        style={{
          fontSize: "16px",
          fontFamily: "Open Sans",
          letterSpacing: ".15px",
        }}
      >
        64
      </text>
    </svg>
    <span
      style={{
        verticalAlign: "middle",
        fontFamily: "Open Sans",
        fontWeight: 700,
        fontSize: "18px",
        letterSpacing: "0.15px",
        color: "#2eb790",
        marginLeft: "0.3rem",
      }}
    >
      Tokens
    </span>
  </>
);

const DeleteIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M5 6.80029H6.2V16.4003H5V6.80029Z" fill="#E4475B" />
    <path
      d="M7.40039 6.80029H8.60039V16.4003H7.40039V6.80029Z"
      fill="#E4475B"
    />
    <path
      d="M9.80078 6.80029H11.0008V16.4003H9.80078V6.80029Z"
      fill="#E4475B"
    />
    <path
      d="M0.199219 3.19971H15.7992V4.39971H0.199219V3.19971Z"
      fill="#E4475B"
    />
    <path
      d="M11 3.20029H9.8V2.60029C9.8 2.24029 9.56 2.00029 9.2 2.00029H6.8C6.44 2.00029 6.2 2.24029 6.2 2.60029V3.20029H5V2.60029C5 1.58029 5.78 0.800293 6.8 0.800293H9.2C10.22 0.800293 11 1.58029 11 2.60029V3.20029Z"
      fill="#E4475B"
    />
    <path
      d="M11.6004 20.0002H4.40039C3.44039 20.0002 2.60039 19.2202 2.48039 18.2602L1.40039 3.86023L2.60039 3.74023L3.68039 18.1402C3.68039 18.5002 4.04039 18.8002 4.40039 18.8002H11.6004C11.9604 18.8002 12.2604 18.5002 12.3204 18.1402L13.4004 3.74023L14.6004 3.86023L13.5204 18.2602C13.4004 19.2202 12.5604 20.0002 11.6004 20.0002Z"
      fill="#E4475B"
    />
  </svg>
);

const LinkTo = () => (
  <svg
    width="18"
    height="20"
    viewBox="0 0 18 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 2.50065C2.5 2.05862 2.67559 1.6347 2.98816 1.32214C3.30072 1.00958 3.72464 0.833984 4.16667 0.833984H12.485C12.927 0.834079 13.3508 1.00974 13.6633 1.32232L17.0117 4.67065C17.3242 4.98314 17.4999 5.40699 17.5 5.84898V17.5006C17.5 17.9427 17.3244 18.3666 17.0118 18.6792C16.6993 18.9917 16.2754 19.1673 15.8333 19.1673H3.95833C3.79257 19.1673 3.6336 19.1015 3.51639 18.9843C3.39918 18.867 3.33333 18.7081 3.33333 18.5423C3.33333 18.3766 3.39918 18.2176 3.51639 18.1004C3.6336 17.9832 3.79257 17.9173 3.95833 17.9173H15.8333C15.9438 17.9173 16.0498 17.8734 16.128 17.7953C16.2061 17.7171 16.25 17.6112 16.25 17.5006V7.08398H12.9167C12.4746 7.08398 12.0507 6.90839 11.7382 6.59583C11.4256 6.28327 11.25 5.85934 11.25 5.41732V2.08398H4.16667C4.05616 2.08398 3.95018 2.12788 3.87204 2.20602C3.7939 2.28416 3.75 2.39014 3.75 2.50065V7.70898C3.75 7.87474 3.68415 8.03371 3.56694 8.15093C3.44973 8.26814 3.29076 8.33398 3.125 8.33398C2.95924 8.33398 2.80027 8.26814 2.68306 8.15093C2.56585 8.03371 2.5 7.87474 2.5 7.70898V2.50065ZM12.5 2.08398V5.41732C12.5 5.52782 12.5439 5.6338 12.622 5.71195C12.7002 5.79009 12.8062 5.83398 12.9167 5.83398H16.25C16.2463 5.72862 16.2029 5.62856 16.1283 5.55398L12.78 2.20565C12.7054 2.13113 12.6054 2.08766 12.5 2.08398ZM7.75667 12.084L6.00333 10.2206C5.94532 10.1612 5.89973 10.0909 5.86922 10.0136C5.83871 9.9364 5.82389 9.85387 5.82564 9.77085C5.82739 9.68783 5.84566 9.60599 5.87939 9.53011C5.91312 9.45424 5.96163 9.38584 6.0221 9.32892C6.08256 9.272 6.15376 9.2277 6.23153 9.19861C6.3093 9.16952 6.3921 9.15622 6.47507 9.15948C6.55804 9.16274 6.63954 9.18251 6.71478 9.21762C6.79003 9.25274 6.85753 9.30249 6.91333 9.36398L9.65833 12.2807C9.76744 12.3966 9.82819 12.5498 9.82819 12.709C9.82819 12.8682 9.76744 13.0214 9.65833 13.1373L6.91333 16.054C6.85753 16.1155 6.79003 16.1652 6.71478 16.2003C6.63954 16.2355 6.55804 16.2552 6.47507 16.2585C6.3921 16.2618 6.3093 16.2484 6.23153 16.2194C6.15376 16.1903 6.08256 16.146 6.0221 16.089C5.96163 16.0321 5.91312 15.9637 5.87939 15.8879C5.84566 15.812 5.82739 15.7301 5.82564 15.6471C5.82389 15.5641 5.83871 15.4816 5.86922 15.4043C5.89973 15.3271 5.94532 15.2567 6.00333 15.1973L7.75667 13.334H3.40833C2.83591 13.334 2.28693 13.5614 1.88216 13.9661C1.4774 14.3709 1.25 14.9199 1.25 15.4923V18.1256C1.25 18.2914 1.18415 18.4504 1.06694 18.5676C0.949731 18.6848 0.79076 18.7506 0.625 18.7506C0.45924 18.7506 0.300269 18.6848 0.183058 18.5676C0.065848 18.4504 0 18.2914 0 18.1256L0 15.4923C0 14.5884 0.359091 13.7214 0.998278 13.0823C1.63746 12.4431 2.50439 12.084 3.40833 12.084H7.75667Z"
      fill="#2eb790"
    />
  </svg>
);

const PlusButton = () => (
  <svg
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="24" r="24" fill="#2eb790" />
    <g filter="url(#filter0_d_7181_24743)">
      <path
        d="M24.9987 7.3335C15.7948 7.3335 8.33203 14.7963 8.33203 24.0002C8.33203 33.204 15.7948 40.6668 24.9987 40.6668C34.2026 40.6668 41.6654 33.204 41.6654 24.0002C41.6654 14.7963 34.2026 7.3335 24.9987 7.3335Z"
        fill="white"
      />
    </g>
    <path
      d="M32.1875 22.75H26.25V16.8125C26.25 16.6406 26.1094 16.5 25.9375 16.5H24.0625C23.8906 16.5 23.75 16.6406 23.75 16.8125V22.75H17.8125C17.6406 22.75 17.5 22.8906 17.5 23.0625V24.9375C17.5 25.1094 17.6406 25.25 17.8125 25.25H23.75V31.1875C23.75 31.3594 23.8906 31.5 24.0625 31.5H25.9375C26.1094 31.5 26.25 31.3594 26.25 31.1875V25.25H32.1875C32.3594 25.25 32.5 25.1094 32.5 24.9375V23.0625C32.5 22.8906 32.3594 22.75 32.1875 22.75Z"
      fill="#2eb790"
    />
    <defs>
      <filter
        id="filter0_d_7181_24743"
        x="0.332031"
        y="1.3335"
        width="49.334"
        height="49.3335"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7181_24743"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7181_24743"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const PlusButtonDisabled = () => (
  <svg
    width="50"
    height="51"
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="25" cy="24" r="24" fill="#2eb790" />
    <g filter="url(#filter0_d_7181_25429)">
      <path
        d="M24.9987 7.3335C15.7948 7.3335 8.33203 14.7963 8.33203 24.0002C8.33203 33.204 15.7948 40.6668 24.9987 40.6668C34.2026 40.6668 41.6654 33.204 41.6654 24.0002C41.6654 14.7963 34.2026 7.3335 24.9987 7.3335Z"
        fill="#D8D8D8"
      />
    </g>
    <path
      d="M32.1875 22.75H26.25V16.8125C26.25 16.6406 26.1094 16.5 25.9375 16.5H24.0625C23.8906 16.5 23.75 16.6406 23.75 16.8125V22.75H17.8125C17.6406 22.75 17.5 22.8906 17.5 23.0625V24.9375C17.5 25.1094 17.6406 25.25 17.8125 25.25H23.75V31.1875C23.75 31.3594 23.8906 31.5 24.0625 31.5H25.9375C26.1094 31.5 26.25 31.3594 26.25 31.1875V25.25H32.1875C32.3594 25.25 32.5 25.1094 32.5 24.9375V23.0625C32.5 22.8906 32.3594 22.75 32.1875 22.75Z"
      fill="#2eb790"
    />
    <defs>
      <filter
        id="filter0_d_7181_25429"
        x="0.332031"
        y="1.3335"
        width="49.334"
        height="49.3335"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7181_25429"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7181_25429"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const MinusButton = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="24" cy="24" r="24" fill="#2eb790" />
    <g filter="url(#filter0_d_7181_24748)">
      <path
        d="M23.9987 7.3335C14.7948 7.3335 7.33203 14.7963 7.33203 24.0002C7.33203 33.204 14.7948 40.6668 23.9987 40.6668C33.2026 40.6668 40.6654 33.204 40.6654 24.0002C40.6654 14.7963 33.2026 7.3335 23.9987 7.3335Z"
        fill="white"
      />
    </g>
    <path
      d="M16.5 23.0625C16.5 22.8906 16.6406 22.75 16.8125 22.75H31.1875C31.3594 22.75 31.5 22.8906 31.5 23.0625V24.9375C31.5 25.1094 31.3594 25.25 31.1875 25.25H16.8125C16.6406 25.25 16.5 25.1094 16.5 24.9375V23.0625Z"
      fill="#2eb790"
    />
    <defs>
      <filter
        id="filter0_d_7181_24748"
        x="3.33203"
        y="5.3335"
        width="41.334"
        height="41.3335"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_7181_24748"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_7181_24748"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
const TotalBreak = () => (
  <svg
    width="341"
    height="3"
    viewBox="0 0 341 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.285156 1.56079H340.995"
      stroke="#D8D8D8"
      strokeWidth="1.37383"
    />
  </svg>
);

const TicketStubComplete = () => (
  <svg
    width="390"
    height="284"
    viewBox="0 0 390 284"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M128.367 245.11C9.04088 294.462 -20.626 281.96 -20.626 281.96L-28.5371 -160.374H250.99C250.99 -160.374 416.757 -126.577 434.265 -33.3731C446.132 29.7983 426.068 40.1357 417.958 100.654C409.848 161.173 401.472 220.178 360.944 245.11C305.805 279.031 247.694 195.758 128.367 245.11Z"
      fill="#2eb790"
    />
  </svg>
);

export {
  CloseModal,
  MoreOptions,
  CloudUpload,
  SearchIcon,
  Remove,
  SmallRemove,
  Add,
  CalendarIcon,
  EditArrow,
  StickerBlue,
  PremiumTeamSticker,
  OrganizationSticker,
  StickerOrange,
  Token14,
  Token50,
  Token64,
  DeleteIcon,
  LinkTo,
  TokenBackground,
  TicketStubComplete,
  PlusButton,
  TotalBreak,
  MinusButton,
  MobileNavToken,
  PlusButtonDisabled,
};
